import { Component, Inject, OnInit } from '@angular/core';
import { CoreLanguageService } from '../../services/language.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';

interface ErrorDialogModalData {
  title: string | (() => string);
  description?: string | (() => string);
}

@Component({
  selector: 'errorDialog',
  templateUrl: 'errorDialog.component.html',
  styleUrls: ['./errorDialog.component.scss']
})

export class ErrorDialogComponent implements OnInit {
  public error_msg: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public modalData: ErrorDialogModalData,
    private _coreLanguageService: CoreLanguageService,
    private dialogRef: MatDialogRef<ErrorDialogComponent>,
  ) { }

  ngOnInit() {
    const me = this;
  }

  public evaluateLanguageString(value: string | (() => string) | boolean): string {
    const me = this;
    if (typeof value === "string") {
      if (value.startsWith("ph")) {
        return me._coreLanguageService.value(value);
      } else {
        return value;
      }
    } else if (typeof value === "function") {
      return value();
    }
  }

  public confirmationBtn() {
    const me = this;
    me.dialogRef.close();
  }
}